"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computePageLimit;

function computePageLimit(entriesPerPage) {
  // Request an additional item to determine whether the last page of the
  // resource was reached. The pagination reducer will slice the list of
  // resources returned by the API call.
  return entriesPerPage + 1;
}